import { NotificationManager } from '@atlas/core';

const POPUP_ID = 'storePurchaseConfirmation';

export const openStorePurchaseConfirmationPopup = ({ image, item_id, name }) => {
  if (!item_id || !name) return false;

  NotificationManager.display({
    data: { image, item_id, name },
    id: POPUP_ID,
    type: 'storePurchaseConfirmation',
  });

  return true;
};
